import SVG from "react-inlinesvg";

const Loader = () => {
    return (
        <>
            <div className="loader-overlay">
                <div className="loader-body">
                    <SVG
                        className="header-logo"
                        src="Assets/Images/Icons/loader.svg"
                        width="198"
                        height="122"
                        title={"Loading..."}
                    />
                </div>
            </div>
        </>
    );
}

export default Loader;